import React, { useState, useEffect } from 'react';
import axios from 'axios';

function NaverLogin() {
  const [naverLogin, setNaverLogin] = useState(null);

  const logout = () => {
    if (naverLogin) {
      const { accessToken } = naverLogin.accessToken;
      const url = `/oauth2.0/token?grant_type=delete&client_id=daeJ61HJaYkV9N8_pOgp&client_secret=uu9N_My431&access_token=${accessToken}&service_provider=NAVER`;
      axios.get(url).then((res) => {
        console.log(res.data);
      });
    }
  };

  useEffect(() => {
    const loadNaverSDK = async () => {
      if (!window.naver) {
        const script = document.createElement('script');
        script.src = 'https://static.nid.naver.com/js/naveridlogin_js_sdk_2.0.2.js';
        script.onload = () => initNaverLogin();
        document.head.appendChild(script);
      } else {
        initNaverLogin();
      }
    };

    const initNaverLogin = () => {
      const naverLoginInstance = new window.naver.LoginWithNaverId({
        clientId: 'daeJ61HJaYkV9N8_pOgp',
        callbackUrl: 'http://localhost:3000/React-LCDC/Login',
        isPopup: false,
        loginButton: { color: 'green', type: 3, height: 60 },
      });

      setNaverLogin(naverLoginInstance);

      naverLoginInstance.init();
      naverLoginInstance.getLoginStatus((status) => {
        if (status) {
          console.log(status);
          console.log(naverLoginInstance.user);
          const email = naverLoginInstance.user.getEmail();
          if (email === undefined || email === null) {
            alert('이메일은 필수정보입니다.\n정보제공을 동의해주세요.');
            naverLoginInstance.reprompt();
            return;
          }
        } else {
          console.log('callback 처리 실패');
        }
      });
    };

    loadNaverSDK();
  }, []);

  return (
    <div id='NaverLogin'>
      <div id='naverIdLogin'></div>
      <button className='NaverLogout' type="button" onClick={logout}>로그아웃</button>
    </div>
  );
}

export default NaverLogin;
